import { NoteSchema } from '../base/note.js';
export const InternalNoteCommandSchema = NoteSchema.omit({
    id: true,
});
export const NoteCommandSchema = NoteSchema.omit({
    id: true,
});
